export class Logger {

    constructor(private enabled: boolean) {}

    log(message: string | object):void {
        !this.enabled ? null : console.log(`[ec] ${message}`)
    }
    
    info(message: string| object):void {
        !this.enabled ? null : console.log(`[ec] %c ${message}`, 'color: gray')
    }

    warn(message: string| object):void {
        !this.enabled ? null : console.log(`[ec] %c ${message}`, 'color: #a3a300')
    }

    error(message: string| object):void {
        !this.enabled ? null : console.log(`[ec] %c ${message}`, 'color: red')
    }
    
}